import type { IChangeLog, IChangeLogResponse, IChangeLogWhatsNew } from '@/interfaces/agency/change-log';
import changeLogService from '@/services/agency/change-log';

export const useChangeLogStore = defineStore('changeLog', {
  state: () => ({
    isLoading: false,
    changeLog: [] as IChangeLog[],
    changeLogById: {} as IChangeLogWhatsNew,
    changeLogWhatsNew: [] as IChangeLogWhatsNew[],
    changeLogLast7days: [] as IChangeLogWhatsNew[],
    changeLogResponse: {} as IChangeLogResponse,
    changeLogQuery: {
      limit: null,
      page: null,
      sortBy: null as string | null,
      order: 'DESC' as string,
      mapped: null as boolean | null, // true || false
      dateFrom: null as string | null,
      dateTo: null as string | null
    }
  }),

  getters: {
    getChangeLog: state => state.changeLog,
    getChangeLogWhatsNew: state => state.changeLogWhatsNew,
    getChangeLogLast7days: state => state.changeLogLast7days
  },

  actions: {
    async fetchChangeLog(append = false) {
      const { data } = await changeLogService.fetchChangeLog(this.changeLogQuery);

      this.changeLogResponse = data;

      if (append) {
        // Append new changeLog to existing ones
        this.changeLog = [...this.changeLog, ...data.data];
      } else {
        // Replace changeLog
        this.changeLog = data.data;
      }
    },

    async fetchChangeLogById(id: number) {
      const { data } = await changeLogService.fetchChangeLogById(id);

      this.changeLogById = data;
    },

    async fetchChangeLogLast7days(startDate: string, endDate: string) {
      const query = {
        ...this.changeLogQuery,
        dateFrom: startDate,
        dateTo: endDate
      };

      const { data } = await changeLogService.fetchChangeLogWhatsNew(query);

      this.changeLogLast7days = data.data;
    },

    async fetchChangeLogWhatsNew(startDate: string, endDate: string) {
      this.isLoading = true;
      try {
        const query = {
          ...this.changeLogQuery,
          dateFrom: startDate,
          dateTo: endDate
        };

        const { data } = await changeLogService.fetchChangeLogWhatsNew(query);

        this.changeLogWhatsNew = data.data;
      } finally {
        this.isLoading = false;
      }
    },

    resetNotificationQuery() {
      this.changeLogQuery = {
        limit: null,
        page: null,
        sortBy: null,
        order: 'DESC',
        mapped: null,
        dateFrom: null,
        dateTo: null
      };
    }
  }
});
